/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAntennaBars1 = createReactComponent("outline", "antenna-bars-1", "IconAntennaBars1", [["path", { "d": "M6 18l0 .01", "key": "svg-0" }], ["path", { "d": "M10 18l0 .01", "key": "svg-1" }], ["path", { "d": "M14 18l0 .01", "key": "svg-2" }], ["path", { "d": "M18 18l0 .01", "key": "svg-3" }]]);

export { IconAntennaBars1 as default };
//# sourceMappingURL=IconAntennaBars1.mjs.map
